import BaseEndpoint from '@/api/endpoints/base-endpoint'
export default class HallGroupEndpoint extends BaseEndpoint {}
